import { appConstants } from "JS/Helpers/Constants";
import { config } from "JS/Config";
import { ConsentText } from "JS/Models/ConsentForm";
import { BaseService } from "../BaseService";

export class ConsentTextService extends BaseService {
    public getConsentFormText(): Promise<ConsentText> {
        return this.ngCall<ConsentText>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.mediaEssentials.bucketName,
                    filePath: `ConsentForm/${config.consentForm.fileName}`,
                },
            },
        ).then((response) => response.data);
    }
}
